export enum FILE_STATUSES {
  ON_CHECK = "check_for_viruses",
  CHECKED = "clean",
  SUCCESS = "done",
  REJECT = "reject",
  ERROR = "error",
}
